import React from 'react';
import { Stack, Box } from '@mui/material';
import Lottie from 'react-lottie';
import { styles } from './styles';
import felixSearching from '../../AIStudio/SharedComponents/Graphics/felix-searching.json';
import felixLoading from '../../AIStudio/SharedComponents/Graphics/felix-loading.json';

export default function FelixAnimation({
  progressVisible,
  transitioningStep,
  currentStep
}: {
  progressVisible: boolean;
  transitioningStep: boolean;
  currentStep: string;
}) {
  const loadingAnimation = {
    loop: true,
    autoplay: true,
    animationData: felixLoading,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  const searchingAnimation = {
    loop: true,
    autoplay: true,
    animationData: felixSearching,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Box sx={{ position: 'relative', height: '55px', width: '55px' }}>
        <Box
          sx={{
            ...styles.animationWrapperLarge,
            opacity: progressVisible ? 0 : 1
          }}
        >
          <Lottie options={loadingAnimation} style={styles.animationLottie} />
        </Box>
        <Box
          sx={{
            ...styles.fadedFull,
            opacity: progressVisible ? 1 : 0
          }}
        >
          <Lottie options={searchingAnimation} style={styles.animationLottieSmall} />
        </Box>
      </Box>
      <Box sx={styles.felixDescription}>
        <Stack sx={{ width: '100%' }}>
          <em
            style={{
              opacity: transitioningStep ? 0 : 1,
              transition: 'opacity 0.3s ease-in-out',
              color: '#2D388D',
              fontSize: '16px',
              fontWeight: '600',
              lineHeight: '20px'
            }}
          >
            {currentStep}
          </em>
        </Stack>
      </Box>
    </Stack>
  );
}
